import { useAuthActions } from '@contexts/AuthContext';
import { ACCOUNT } from '@routes';
import styles from '@styles/components/header.module.scss';
import { Dropdown } from 'antd';
import { Link } from 'react-router-dom';
import useCopyReferral from '../useCopyReferral';
import DriveButton from './DriveButton';
import MenuTabs from './MenuTabs';

type Props = {
  visible: boolean;
  children: any;
};

const MobileMenuDropdown = ({ visible, children }: Props) => {
  const { logout } = useAuthActions();
  const { canCopyReferral, copyReferral } = useCopyReferral();

  const menuFooter = (
    <div className={styles.mobileMenuFooter}>
      <Link to={ACCOUNT}>
        <span>My account</span>
      </Link>
      {canCopyReferral ? (
        <div onClick={copyReferral} style={{ cursor: 'pointer' }}>
          <span>Copy referral link</span>
        </div>
      ) : null}
      <div onClick={logout} style={{ cursor: 'pointer' }}>
        <span>Log out</span>
      </div>
      <DriveButton />
    </div>
  );

  const mobileMenuItems = (
    <div className={styles.mobileMenu}>
      <div className={styles.mobileMenuBody}>
        <MenuTabs />
      </div>
      {menuFooter}
    </div>
  );

  return (
    <div>
      <Dropdown overlay={mobileMenuItems} placement="bottomLeft" visible={visible}>
        {children}
      </Dropdown>
    </div>
  );
};

export default MobileMenuDropdown;
